export function FileMagnifyingGlassIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M4.66667 2.71875H7.58333V4.95312C7.58333 5.96367 8.42188 6.78125 9.45833 6.78125H11.75V12.875C11.75 13.0984 11.5625 13.2812 11.3333 13.2812H4.66667C4.4375 13.2812 4.25 13.0984 4.25 12.875V3.125C4.25 2.90156 4.4375 2.71875 4.66667 2.71875ZM8.83333 3.22402L11.2318 5.5625H9.45833C9.11198 5.5625 8.83333 5.29082 8.83333 4.95312V3.22402ZM4.66667 1.5C3.7474 1.5 3 2.22871 3 3.125V12.875C3 13.7713 3.7474 14.5 4.66667 14.5H11.3333C12.2526 14.5 13 13.7713 13 12.875V6.23535C13 5.80371 12.8255 5.38984 12.513 5.08516L9.32031 1.9748C9.00781 1.67012 8.58594 1.5 8.14323 1.5H4.66667ZM9.83594 9.625C9.83594 8.41133 8.82812 7.42871 7.58333 7.42871C6.33854 7.42871 5.33073 8.41133 5.33073 9.625C5.33073 10.8387 6.33854 11.8213 7.58333 11.8213C7.97917 11.8213 8.34896 11.7223 8.67187 11.5496L9.64062 12.4967C9.88542 12.7354 10.2812 12.7354 10.5234 12.4992C10.7656 12.2631 10.7682 11.8746 10.526 11.6385L9.55729 10.6889C9.73698 10.374 9.83854 10.0109 9.83854 9.62754L9.83594 9.625ZM7.58333 8.55859C8.1875 8.55859 8.67708 9.03594 8.67708 9.625C8.67708 10.2141 8.1875 10.6914 7.58333 10.6914C6.97917 10.6914 6.48958 10.2141 6.48958 9.625C6.48958 9.03594 6.97917 8.55859 7.58333 8.55859Z"
        fill="currentColor"
      />
    </svg>
  );
}
